import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { setErrorPanel } from '../../redux/utilities/utils.actions';
import {
	setSubscription,
	setShowSubscribe,
} from '../../redux/profile/profile.actions';
import { useForm } from 'react-hook-form';
import Modal from 'react-bootstrap/Modal';

const SubscribeForUpdates = ({
	phone,
	email,
	setShowSubscribe,
	showSubscribe,
	error: { panelClass, panelMsg },
	setSubscription,
}) => {
	const { register, handleSubmit, watch, errors } = useForm();
	const handleClose = () => setShowSubscribe(false);
	const revealSubscription = watch('isSubscribe');

	const onSubmit = (data) => {
		if (!data.email) {
			data['email'] = email;
		}
		if (!data.phone) {
			data['phone'] = phone;
		}
		setSubscription({ ...data });
	};

	return (
		<Modal
			show={showSubscribe}
			size="xl"
			dialogClassName="modal-90w"
			onHide={handleClose}
			backdrop={true}
			keyboard={false}
		>
			<Modal.Header closeButton></Modal.Header>
			<Modal.Body size="md">
				<p style={{ padding: '0' }}>
					Would you like to receive updates (and offers) on our English courses on
					Email and SMS?
				</p>
				<div className={panelClass}>{panelMsg}</div>
				<form onSubmit={handleSubmit(onSubmit)} className="subscribeForm">
					<div className="funkyradio">
						<span className="profileError">
							{errors.isSubscribe?.type === 'required' && 'Notification is required'}
						</span>
						<div className="funkyradio-success">
							<input
								type="radio"
								name="isSubscribe"
								id="radio1tt"
								ref={register({
									required: true,
								})}
								value={1}
								defaultChecked={false}
							/>
							<label htmlFor="radio1tt">Yes</label>
						</div>
						<div className="funkyradio-success">
							<input
								type="radio"
								name="isSubscribe"
								value={0}
								defaultChecked={false}
								ref={register({
									required: true,
								})}
								id="radio2tt"
							/>
							<label htmlFor="radio2tt">No</label>
						</div>
					</div>

					{revealSubscription === '1' && !phone ? (
						<div className="form-group" style={{ marginTop: '10px' }}>
							<label className="control-label" htmlFor="phone">
								Phone
							</label>
							<small style={{ paddingLeft: '5px' }}> (optional)</small>
							<input
								type="text"
								className="form-control"
								name="phone"
								ref={register({
									pattern: /^[6789]\d{9}$/,
								})}
								defaultValue={phone}
							/>

							<span className="profileError">
								{errors.phone?.type === 'pattern' && 'Incorrect mobile number'}
							</span>
						</div>
					) : null}

					{revealSubscription === '1' && !email ? (
						<div className="form-group" style={{ marginTop: '10px' }}>
							<label className="control-label" htmlFor="email">
								E-mail
							</label>
							<small style={{ paddingLeft: '5px' }}> (optional)</small>
							<input
								type="text"
								className="form-control"
								name="email"
								ref={register({
									pattern: /^[_a-zA-Z0-9-]+(\.[_a-zA-Z0-9-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,4})$/,
								})}
								defaultValue={email}
							/>

							<span className="profileError">
								{errors.email?.type === 'pattern' && 'Incorrect email id'}
							</span>
						</div>
					) : null}
					<button
						aria-label="next"
						className="btn btn-primary nextBtn "
						type="submit"
					>
						Submit
					</button>
				</form>
			</Modal.Body>
		</Modal>
	);
};

const mapStateToProps = (state) => {
	const { phone, email } = state.rootReducer.userDetails;
	const { userPhone, userEmail } = state.rootReducer.loginDetails;
	return {
		phone: phone || userPhone,
		email: email || userEmail,
		error: state.rootReducer.utils.errorPanel,
		showSubscribe: state.rootReducer.profileDetails.showSubscribe,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		setErrorMsg: (obj) => dispatch(setErrorPanel(obj)),
		setSubscription: (obj) => dispatch(setSubscription(obj)),
		setShowSubscribe: (val) => dispatch(setShowSubscribe(val)),
	};
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(
	SubscribeForUpdates,
);
